<template>
  <transition name="modal">
    <div class="modal-mask" :style="{ position: position }">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <button class="close" @click="$emit('close')">&times;</button>
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-primary" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name : "modal",
    props : [
      "position"
    ]
  }
</script>

<style lang="scss">
.modal-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  width: 600px;
  margin: 50px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: none;
  @media (max-width:600px){
    width: 100%;
  }
}

.modal-header .close {
  border: 0;
  background: transparent;
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
  &:focus {
    outline: 1px dotted #999;
  }
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 0;
  overflow: visible;
}

.modal-container .modal-footer {
  padding: 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
